import { PATHS } from './paths';

/**
 * Earlier addresses of Vendor Management screens that have moved, so
 * bookmarks, shared links and reminder emails already sent keep working.
 * A `prefix` rule carries everything after the old prefix (ids, sub-pages);
 * every rule keeps the query string and hash.
 */
export interface LegacyRedirectRule {
  from: string;
  to: string;
  prefix?: boolean;
}

export const LEGACY_REDIRECTS: readonly LegacyRedirectRule[] = [
  // "Expenses" became Supplier Bills: /expenses/:id/… → /payables/:id/…
  { from: '/finance/vendor-management/expenses', to: PATHS.app.financeExpenses, prefix: true },
  // "Payments" became the Payment Register (Accounts Payable).
  { from: '/finance/payments', to: PATHS.app.financePayments },
  { from: '/finance/vendor-management/payments', to: PATHS.app.financePayments },
  // Renewal reminder emails linked here before finance-service pointed them at
  // the Finance Overview.
  { from: '/finance/vendor-management/overview', to: PATHS.app.financeOverview },
];

/** The route path a rule answers on. */
export const legacyRoutePath = (rule: LegacyRedirectRule): string =>
  rule.prefix ? `${rule.from}/*` : rule.from;

/**
 * The current address rewritten to the rule's new one. Route matching ignores
 * case, so the old prefix is compared the same way (ids keep their case).
 */
export function legacyTarget(
  rule: LegacyRedirectRule,
  location: { pathname: string; search: string; hash: string },
): string {
  const rest =
    rule.prefix && location.pathname.toLowerCase().startsWith(rule.from.toLowerCase())
      ? location.pathname.slice(rule.from.length)
      : '';
  return `${rule.to}${rest}${location.search}${location.hash}`;
}
